// components/VpnNotice/bus.ts
//
// Module-level pub/sub so the API layer — which runs outside React — can raise
// the "turn your VPN off" sheet. Same shape as KycContainer/kycPromptBus. Keep
// this file React-free: services/api.ts imports it.

type Listener = () => void;

let listeners: Listener[] = [];

export const openVpnNotice = (): void => {
  listeners.forEach((l) => l());
};

export const subscribeVpnNotice = (listener: Listener): (() => void) => {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
};

/**
 * Whether a VPN notice is mounted to take a 406. Only the deposit and
 * withdrawal pages mount one; everywhere else the API layer keeps its toast.
 */
export const hasVpnNoticeHost = (): boolean => listeners.length > 0;

/**
 * A 406 is the backend refusing the request because the IP is outside Iran.
 * Nothing about the request itself was wrong, so callers must not treat it as
 * a failed deposit, a rejected withdrawal, or a reason to clear the form.
 */
export const isVpnBlocked = (error: unknown): boolean =>
  (error as { status?: unknown } | null | undefined)?.status === 406;
